import React from "react";
import Plot from "react-plotly.js";

const PcaPlot = ({fdata}) => {
    var xdata = [];
    var ydata = [];
    
    for (let i=0;i<fdata.length;i++){
        xdata[i] = fdata[i][0];
        ydata[i] = fdata[i][1];
    }

    const scatterplot = {
            x: xdata,
            y: ydata,
            mode: 'markers',
            type: 'scatter'
    };
    console.log('xdata',xdata);
    console.log('ydata',ydata);
    return(
        <>
        <div>
            <Plot data={[scatterplot]} 
            layout={ {width: 800, height: 500, title: 'Principal Component Analysis',
            xaxis: {title: "Second Components" },
            yaxis: {title: "First Components" }} }/>
        </div>
        </>
    );
};

export default PcaPlot;